module.exports = __webpack_public_path__ + "fonts/思源柔黑-Regular.d0355c20.ttf";